/**
 * Reads leaderboard points from API `awardedPoints` (inline-quiz submit, lesson complete).
 * Supports a positive number or an object with a numeric `total` / `points` field.
 */
export function resolveAwardedPointsValue(awardedPoints: unknown): number | null {
	if (awardedPoints == null) {
		return null;
	}

	if (typeof awardedPoints === "number" && Number.isFinite(awardedPoints) && awardedPoints > 0) {
		return Math.floor(awardedPoints);
	}

	if (typeof awardedPoints === "object") {
		const record = awardedPoints as Record<string, unknown>;
		for (const key of ["total", "points", "value"] as const) {
			const candidate = record[key];
			if (typeof candidate === "number" && Number.isFinite(candidate) && candidate > 0) {
				return Math.floor(candidate);
			}
		}
	}

	return null;
}
